import Utils from "./libs/snake.lib.utils.js";
import Hook from "./libs/snake.lib.hook.js";
import Identity from "./libs/snake.lib.identity.js";
import AnalyticsService from "./libs/snake.lib.analytics.js";
import Validate from "./libs/snake.lib.validate.js";
import Component from "./component.js";
import Tagify from "@yaireo/tagify";
import config from "./config.js";
import ApiService from "./libs/snake.lib.api.js";
import Trace from "./libs/snake.lib.trace.js";
import Summary from "./libs/snake.lib.summary.js";

export default class ComponentAddresses {
    static modalI18nGenericOptions;
    static componentDom;

    static init = async () => {
        // Trace.debug("Component _cmpAddresses");

        // FR-2434
        Summary.showReducedVersion(2);

        this.modalI18nGenericOptions = Component.getModalI18nGenericOptions();

        this.componentDom = document.getElementById(config.routing.sections.addresses.component);

        this.componentDom.innerLoader(true);

        this.componentDom.querySelector(".first-time").classList.add("hidden");

        Component.scrollTo(config.routing.sections.addresses.component);

        if (!(window.snakeCheckout.analyticsShippingEventSent ?? false)) AnalyticsService.checkoutShippingLoad();
        window.snakeCheckout.analyticsShippingEventSent = true;

        if (window.snakeCheckout.accountInfo.data.shippingAddresses.length !== 0) {
            // Trace.warn("address repeater init");

            Utils.initRepeater();
        }

        /**
         * Listener to intercept the Address Add user action and the automatic insert of the first address
         */
        Hook.subscribe("_repeaterAdded", (e) => {
            if (e.detail.repeaterDataReference === "addresses-repeater") {
                // Trace.debug("_cmpAddresses _repeaterAdded");
                // Trace.warn(e);

                const repeaterWrapper = this.componentDom.querySelector("[data-repeater='" + e.detail.repeaterDataReference + "']");
                const repeaterContainer = repeaterWrapper.querySelector("#" + e.detail.repeaterDataReference);
                const index = e.detail.repeaterElementIndex;
                const repeaterLastElement = repeaterContainer.lastElementChild;

                // Trace.log(e.detail.repeaterElementIndex);

                // Trace.log(window.snakeCheckout.accountInfo.data.shippingAddresses[index]);

                repeaterLastElement.dataset.index = index;

                /**
                 * Replace DefaultAddress radio form fields _INDEX_ placeholder on the repeater element
                 */
                repeaterLastElement.querySelectorAll("input, label").forEach((element) => {
                    if (element.tagName === "LABEL") element.htmlFor = element.htmlFor.replace("_INDEX_", index);
                    else element.id = element.id.replace("_INDEX_", index);
                });

                if (window.snakeCheckout.accountInfo.data.shippingAddresses[index] && window.snakeCheckout.accountInfo.data.shippingAddresses[index].defaultAddress) repeaterLastElement.classList.add("border-secondary");

                Hook.attachListener("_editAddress");

                if (!window.snakeCheckout.accountInfo.data.shippingAddresses[index]) {
                    /**
                     * We are manually adding a new address
                     */

                    // Trace.debug("= manual =");

                    // Trace.log(repeaterLastElement);

                    /**
                     * Disable repeater "Add a new address" button
                     */
                    repeaterWrapper.querySelector("[data-add='" + e.detail.repeaterDataReference + "']").disabled = true;

                    repeaterLastElement.querySelector('[data-hook="_editAddress"]').click();
                } else {
                    /**
                     * We are handling the first address repeater automatically added
                     */

                    // Trace.debug("= auto =");

                    repeaterLastElement.querySelector("[type='radio']").checked = window.snakeCheckout.accountInfo.data.shippingAddresses[index].defaultAddress;

                    /**
                     * Replace HTML placeholders on repeater element with user data
                     */
                    repeaterLastElement.querySelector("shippinglabel").innerHTML = window.snakeCheckout.accountInfo.data.shippingAddresses[index].label || "";
                    repeaterLastElement.querySelector("shippingaddress").innerHTML = window.snakeCheckout.accountInfo.data.shippingAddresses[index].addressLine1 || "";
                    repeaterLastElement.querySelector("shippingstreetnumber").innerHTML = window.snakeCheckout.accountInfo.data.shippingAddresses[index].normStreetNum || "";
                    repeaterLastElement.querySelector("shippingzip").innerHTML = window.snakeCheckout.accountInfo.data.shippingAddresses[index].postalCode || "";
                    repeaterLastElement.querySelector("shippingcity").innerHTML = window.snakeCheckout.accountInfo.data.shippingAddresses[index].city || "";
                    repeaterLastElement.querySelector("email").innerHTML = window.snakeCheckout.accountInfo.profile.email || "";
                    repeaterLastElement.querySelector("phone").innerHTML = window.snakeCheckout.accountInfo.data.shippingAddresses[index].phoneNumber || "";
                }

                Hook.attachListener("_setDefaultAddress");
                Hook.attachListener("_setAddress");
                Hook.attachListener("_discardAddress");
            }
        });

        /**
         * Listener to intercept the Address Delete user action
         */
        Hook.subscribe("_repeaterDelete", async (e) => {
            // Trace.debug("_cmpAddresses Hook.subscribe _repeaterDelete");
            // Trace.log(e);

            /**
             * TODO: show confirmation dialog
             */
            // Utils.modal("dialog", true, {text:"Do you want to delete the address?", dismissBtn: this.modalI18nGenericOptions.dismissBtn}, () => {
            //   Utils.modal("dialog", false);
            // });

            const index = e.detail.repeaterElementIndex;

            /**
             * The selected shipping address is not the default one
             */
            if (!window.snakeCheckout.accountInfo.data.shippingAddresses[index].defaultAddress) {
                Utils.spinner("loader", true);

                const shippingAddresses = [...(window.snakeCheckout.accountInfo.data.shippingAddresses || [{}])];
                const billingAddress = { ...(window.snakeCheckout.accountInfo.data.billingAddress || {}) };

                /**
                 * Remove address from the shipping addresses object
                 */
                shippingAddresses.splice(index, 1);

                window.snakeCheckout.accountInfo.data.shippingAddressesOnOtherCountries.forEach((address) => shippingAddresses.push(address));

                if (shippingAddresses && billingAddress) await this.#updateAddresses(shippingAddresses, billingAddress);

                Utils.spinner("loader", false);
            }
        });

        /**
         * Listener to intercept the addresses setAccountInfo call on the Addresses Save user action
         */
        Hook.subscribe("_setAddresses", async () => {
            Utils.spinner("loader", true);

            let selector = null;

            if (window.snakeCheckout.accountInfo.data.shippingAddresses.length === 0) {
                /**
                 * It's the first time the user inserts addresses
                 */
                selector = ".first-time form";
            } else {
                /**
                 * It's not the first time the user inserts addresses
                 */
                selector = ".next-times > form";
            }

            const { shippingAddresses, billingAddress } = this.#prepareAddressesObject(this.componentDom.querySelector(selector));

            if (shippingAddresses && billingAddress) await this.#updateAddresses(shippingAddresses, billingAddress);

            window.snakeCheckout.keepEditingAddresses = false;

            Utils.spinner("loader", false);
        });

        /**
         * Listener to intercept the Addresses Edit user action
         */
        Hook.subscribe("_editAddresses", async () => {
            // Trace.debug("_cmpAddresses Hook.subscribe _editAddresses");
            // Trace.log(window.snakeCheckout.accountInfo);

            Utils.spinner("loader", true);

            Component.setCheckoutStepsVisibility([config.routing.sections.payment.component], false);

            await this.#initAddressesForm();

            this.#handleShippingInstructionFlag();

            this.#handleSameAddressFlag();

            this.#renderUserShippingAddresses();

            Utils.spinner("loader", false);
        });

        /**
         * Listener to intercept the Address Set Default user action
         */
        Hook.subscribe("_setDefaultAddress", async (e) => {
            // Trace.debug("_cmpAddresses Hook.subscribe _setDefaultAddress");
            // Trace.log(e.detail);

            const repeaterItem = e.detail.event.target.closest(".repeater-item");
            const index = repeaterItem.dataset.index;

            // Trace.log(index);

            /**
             * Check if the selected shipping address is not already the default one
             */
            if (window.snakeCheckout.accountInfo.data.shippingAddresses[index] && !window.snakeCheckout.accountInfo.data.shippingAddresses[index].defaultAddress) {
                // Trace.debug("not already checked");

                Utils.spinner("loader", true);

                /**
                 * To handle the CIF/NIF for ES, we show an alert if the default shipping address zip start with 35 or 38 and the taxCode on the billing address is missing
                 */
                const zip = window.snakeCheckout.accountInfo.data.shippingAddresses[index].postalCode;
                if (window.snakeCheckout.currentCountry === "es" && ["35", "38"].some((check) => zip.trim().replace(/\D/gu, "").startsWith(check)) && !window.snakeCheckout.accountInfo.data.billingAddress.taxCode) {
                    Utils.modal("popup", true, { text: window.snakeCheckout.translations["error.defaultaddress.fiscalcode"], dismissBtn: this.modalI18nGenericOptions.dismissBtn });

                    Utils.spinner("loader", false);

                    return;
                }

                const shippingAddresses = [...(window.snakeCheckout.accountInfo.data.shippingAddresses || [{}])];
                let billingAddress = { ...(window.snakeCheckout.accountInfo.data.billingAddress || {}) };

                /**
                 * Set all shipping addresses default value to "false"
                 */
                shippingAddresses.map((element) => {
                    element.defaultAddress = false;
                    return element;
                });

                /**
                 * Set the selected shipping address default value to "true"
                 */
                shippingAddresses[index].defaultAddress = true;

                /**
                 * Check if the billing address must be equal to the default shipping address
                 */
                if (document.getElementById("same-addresses").checked) {
                    /**
                     * To handle the CIF/NIF for ES, we make a copy of the billing address taxCode before overwriting it with the default shipping address
                     */
                    const currentBillingAddressTaxCode = billingAddress.taxCode || "";

                    /**
                     * Populate billing object with User accountInfo shipping data
                     */
                    billingAddress = { ...shippingAddresses[index] };

                    /**
                     * To handle the CIF/NIF for ES, we re-insert the billing address taxCode with the previous saved value
                     */
                    billingAddress.taxCode = currentBillingAddressTaxCode;
                }

                window.snakeCheckout.accountInfo.data.shippingAddressesOnOtherCountries.forEach((address) => shippingAddresses.push(address));

                if (shippingAddresses && billingAddress) await this.#updateAddresses(shippingAddresses, billingAddress);

                Utils.spinner("loader", false);
            }
        });

        /**
         * Listener to intercept the Address Edit user action
         */
        Hook.subscribe("_editAddress", (e) => {
            // Trace.debug("_cmpAddresses Hook.subscribe _editAddress");

            Utils.spinner("loader", true);

            this.#initAddressForm(e);

            Utils.spinner("loader", false);
        });

        /**
         * Listener to intercept the Address Discard Edit user action
         */
        Hook.subscribe("_discardAddress", (e) => {
            // Trace.debug("_cmpAddresses Hook.subscribe _discardAddress");
            // Trace.log(e);

            Utils.spinner("loader", true);

            this.#renderUserShippingAddresses();

            Utils.spinner("loader", false);
        });

        /**
         * Listener to intercept the Address Save user action
         */
        Hook.subscribe("_setAddress", async (e) => {
            // Trace.debug("_cmpAddresses Hook.subscribe _setAddress");
            // Trace.log(e);

            Utils.spinner("loader", true);

            const repeaterItem = e.detail.event.target.closest(".repeater-item");

            const { shippingAddresses, billingAddress } = this.#prepareAddressesObject(repeaterItem.querySelector("form"));

            if (shippingAddresses && billingAddress) await this.#updateAddresses(shippingAddresses, billingAddress);

            window.snakeCheckout.keepEditingAddresses = true;

            Utils.spinner("loader", false);
        });

        if (window.snakeCheckout.accountInfo.data.shippingAddresses.length === 0) {
            /**
             * If the user has to enter addresses for the first time
             */

            // Trace.warn("address first");

            await this.#initAddressesForm();

            this.#handleShippingInstructionFlag();

            this.#handleSameAddressFlag();

            this.componentDom.querySelector(".first-time").classList.remove("hidden");
        } else {
            /**
             * If the user has already entered some addresses
             */
            // Trace.warn("address not first");

            /**
             * On sign-in update the BigCommerce account to add the customer addresses to the already created cart.
             * On edit addresses, update the BigCommerce account and the cart.
             */
            const defaultShippingAddress = window.snakeCheckout.accountInfo.data.shippingAddresses.find((address) => address.defaultAddress);
            let shouldContinue = true;
            if (!document.getElementById("addresses-failure-msg").classList.contains("hidden")) {
                document.getElementById("addresses-failure-msg").classList.add("hidden");
            }
            await ApiService.updateAddresses(window.snakeCheckout.accountInfo.profile.email, defaultShippingAddress, window.snakeCheckout.accountInfo.data.billingAddress)
                .then((response) => {
                    // Trace.debug("Success updateAddresses");

                    if (window.snakeCheckout.currentCountry === "us") {
                        Hook.publish("_commerceCreateAddresses", {
                            detail: response,
                        });
                    }
                })
                .catch((e) => {
                    // Utils.modal("popup", true, this.modalI18nGenericOptions);
                    AnalyticsService.errorEvent("2_address", "technical", "snakeAPI | update user addresses addresses error", e);
                    shouldContinue = false;
                });

            if (!shouldContinue) {
                Hook.publish("_editAddresses");
                window.snakeCheckout.keepEditingAddresses = true;
                document.getElementById("addresses-failure-msg").classList.remove("hidden");
            }

            if (window.snakeCheckout.keepEditingAddresses ?? false) this.#renderUserShippingAddresses();
            else {
                this.#renderUserDefaultShippingAddress();

                if (!Identity.isAgentCustomer()) Component.load(config.routing.sections.payment.component);
            }
        }

        this.componentDom.innerLoader(false);

        Component.setCheckoutStepsVisibility([config.routing.sections.addresses.component], true);
    };

    static #handleShippingInstructionFlag = () => {
        // Trace.warn("handleShippingInstructionFlag");

        const shippingInstructionFlagDom = document.getElementById("shipping-instructions");

        if (!shippingInstructionFlagDom.dataset.events || !shippingInstructionFlagDom.dataset.events.includes("change")) {
            shippingInstructionFlagDom.addEventListener("change", (e) => {
                // Trace.debug("shipping-instructions");
                // Trace.log(e);

                const wrapperClasses = document.getElementById("shipping-instructions-wrapper").classList;
                const addressesForm = e.currentTarget.closest("form");

                if (e.currentTarget.checked) {
                    Validate.attach(addressesForm, (formIsValid) => {
                        // Trace.debug("Validate attach ShippingInstructions check response:");
                        // Trace.log(formIsValid);

                        addressesForm.querySelector('button[type="submit"]').disabled = !formIsValid;
                    });

                    /**
                     * Detach the billing fields if the "same_address" checkbox is active
                     */
                    if (document.getElementById("same-addresses").checked)
                        Validate.detachFields(addressesForm.querySelector("#billing-address"), (formIsValid) => {
                            // Trace.debug("Validate detach ShippingInstructions check response:");
                            // Trace.log(formIsValid);

                            addressesForm.querySelector('button[type="submit"]').disabled = !formIsValid;
                        });

                    wrapperClasses.remove("hidden");
                } else {
                    const field = document.querySelector('[name="shipping[addressLine3]"]');

                    Validate.detachFields(field, (formIsValid) => {
                        // Trace.debug("Validate detach ShippingInstructions check response:");
                        // Trace.log(formIsValid);

                        addressesForm.querySelector('button[type="submit"]').disabled = !formIsValid;
                    });

                    field.value = "";

                    field.classList.remove("valid", "invalid", "error");

                    if (field.parentElement.querySelector(":scope small")) field.parentElement.querySelector(":scope small").remove();

                    wrapperClasses.add("hidden");
                }
            });

            shippingInstructionFlagDom.dataset.events = "change";
        }
    };

    static #handleSameAddressFlag = () => {
        Trace.warn("handleSameAddressFlag");

        const sameAddressesFlagDom = document.getElementById("same-addresses");

        if (!sameAddressesFlagDom.dataset.events || !sameAddressesFlagDom.dataset.events.includes("change")) {
            sameAddressesFlagDom.addEventListener("change", (e) => {
                Trace.debug("same-addresses change");
                // Trace.log(e);

                if (!e.currentTarget.checked) {
                    /**
                     * Populate billing address form with data on user accountInfo, in this way if the default address is changed and the
                     * user open the edit form we will have the correct data
                     */
                    this.componentDom.querySelectorAll("#billing-address input").forEach((element) => {
                        const match = element.name.match(/\[(.*?)\]/g);

                        if (match) {
                            const fieldName = match[0].replace(/[[\]]/g, "");

                            Trace.debug(fieldName);

                            element.value = window.snakeCheckout.accountInfo.data.billingAddress[fieldName] || "";

                            if (fieldName === "country") element.value = config.countries[window.snakeCheckout.currentCountry].displayName;

                            if (fieldName === "phoneNumber") Utils.setPhoneNumberValue(element);
                        }
                    });
                }

                const wrapperClasses = document.getElementById("same-addresses-wrapper").classList;
                const addressesForm = e.currentTarget.closest("form");

                Validate.attach(addressesForm, (formIsValid) => {
                    // Trace.debug("[02] Validate attach SameAddress check response:");
                    // Trace.log(formIsValid);

                    addressesForm.querySelector('button[type="submit"]').disabled = !formIsValid;
                });

                if (!e.currentTarget.checked) {
                    /**
                     * Detach the Shipping Instruction field if the checkbox is not active
                     */
                    if (!document.getElementById("shipping-instructions").checked)
                        Validate.detachFields(document.querySelector('[name="shipping[addressLine3]"]'), (formIsValid) => {
                            // Trace.debug("[03] Validate attach SameAddress check response:");
                            // Trace.log(formIsValid);

                            addressesForm.querySelector('button[type="submit"]').disabled = !formIsValid;
                        });

                    wrapperClasses.remove("hidden");
                } else {
                    Validate.detachFields(addressesForm.querySelector("#billing-address"), (formIsValid) => {
                        // Trace.debug("[D01] Validate detach SameAddress check response:");
                        // Trace.log(formIsValid);

                        addressesForm.querySelector('button[type="submit"]').disabled = !formIsValid;
                    });

                    wrapperClasses.add("hidden");
                }
            });

            sameAddressesFlagDom.dataset.events = "change";
        }

        /**
         * Uncheck the Same Addresses flag if shipping and billing addresses are the same
         */
        const defaultShippingAddress = window.snakeCheckout.accountInfo.data.shippingAddresses.find((address) => address.defaultAddress) || {};
        const billingAddress = window.snakeCheckout.accountInfo.data.billingAddress || {};

        Trace.debug("uncheck same address");

        Trace.debug(defaultShippingAddress);
        Trace.debug(billingAddress);

        if (defaultShippingAddress.length !== 0 && billingAddress.length !== 0) {
            const skipFields = ["phoneIsValid", "county", "label", "defaultAddress", "addressLine3"];
            let isSameAddresses = true;

            for (const [fieldName, shippingFieldValue] of Object.entries(defaultShippingAddress)) {
                Trace.debug(fieldName);
                Trace.debug(billingAddress[fieldName]);
                Trace.debug(shippingFieldValue);

                if (!skipFields.includes(fieldName) && billingAddress[fieldName] !== shippingFieldValue) {
                    isSameAddresses = false;
                    break;
                }
            }

            Trace.debug(isSameAddresses);

            if (!isSameAddresses) sameAddressesFlagDom.click();
        }
    };

    static #initAddressesForm = async () => {
        // Trace.warn("address form init");

        let addressesForm;

        const initStateFields = (fields) => {
            fields.forEach((item) => {
                if (item.dataset.tagify !== "init") {
                    // eslint-disable-next-line no-new
                    new Tagify(item, {
                        userInput: false,
                        enforceWhitelist: true,
                        mode: "select",
                        tagTextProp: "label",
                        dropdown: {
                            mapValueTo: "label",
                            maxItems: 100,
                            sortby: "startsWith",
                        },
                        whitelist: config.countries[window.snakeCheckout.currentCountry].states.sort((a, b) => (a.label > b.label ? 1 : -1)),
                        originalInputValueFormat: (valuesArr) => valuesArr.map((item) => item.value),
                    });

                    item.dataset.tagify = "init";
                }
            });
        };

        const initPhoneFields = (fields) => {
            fields.forEach((item) => {
                Utils.initPhoneNumber(item, window.snakeCheckout.currentCountry, config.countries);
            });
        };

        if (!window.snakeCheckout.gaddressLoaded) {
            // Trace.debug("Load gaddress");
            await Identity._gaddressLoader();
        }

        if (window.snakeCheckout.accountInfo.data.shippingAddresses.length === 0) {
            // Trace.warn("address form init first");

            addressesForm = this.componentDom.querySelector(".first-time > form");

            /**
             * we use just one form to handle the shipping address and the billing address together, so we move the fields on the "first access" HTML form
             */
            addressesForm.append(this.componentDom.querySelector(".next-times #billing-address"));

            /**
             * Populate firstname, lastname and country on shipping and billing forms
             */
            Object.entries(Object.fromEntries(new FormData(addressesForm))).forEach((element) => {
                // Trace.warn("address populate");

                const [key, value] = element;

                if (key.endsWith("firstName", key.length - 1)) {
                    addressesForm.querySelector('input[name="' + key + '"]').value = value === "" ? window.snakeCheckout.accountInfo.profile.firstName || "" : "";
                }

                if (key.endsWith("lastName", key.length - 1)) {
                    addressesForm.querySelector('input[name="' + key + '"]').value = value === "" ? window.snakeCheckout.accountInfo.profile.lastName || "" : "";
                }

                if (key.endsWith("country", key.length - 1)) addressesForm.querySelector('input[name="' + key + '"]').value = config.countries[window.snakeCheckout.currentCountry].displayName;
            });

            if (window.snakeCheckout.currentCountry === "us") initStateFields(addressesForm.querySelectorAll("#shipping-state[data-tagify='true'], #billing-state[data-tagify='true']"));

            initPhoneFields(addressesForm.querySelectorAll("#shipping-phone, #billing-phone"));
        } else {
            // Trace.warn("address form init next");

            addressesForm = this.componentDom.querySelector(".next-times > form");

            /**
             * Move back the billing fields on the "next access" HTML form
             */
            addressesForm.append(this.componentDom.querySelector("#billing-address"));

            if (window.snakeCheckout.currentCountry === "us") initStateFields(this.componentDom.querySelectorAll("#billing-state[data-tagify='true']"));

            initPhoneFields(this.componentDom.querySelectorAll("#billing-phone"));

            /**
             * Populate billing address form with data on accountInfo, in this way if the user open the billing edit form there
             * is the correct data
             */
            addressesForm.querySelectorAll("input").forEach((element) => {
                const match = element.name.match(/\[(.*?)\]/g);

                if (match) {
                    const fieldName = match[0].replace(/[[\]]/g, "");
                    element.value = window.snakeCheckout.accountInfo.data.billingAddress[fieldName] || "";

                    if (fieldName === "phoneNumber") Utils.setPhoneNumberValue(element);
                }
            });

            addressesForm.querySelector('button[type="submit"]').disabled = false;
        }

        if (!addressesForm.dataset.validationAttached) {
            Validate.attach(addressesForm, (formIsValid) => {
                // Trace.debug("[01] Validate attach addressesForm response: " + addressesForm.classList.toString());
                // Trace.log(formIsValid);

                // TODO: remove condition
                if (addressesForm.querySelector('button[type="submit"]')) addressesForm.querySelector('button[type="submit"]').disabled = !formIsValid;
            });
        }

        if (window.snakeCheckout.accountInfo.data.shippingAddresses.length === 0) {
            /**
             * we detach the billing fields because the "same_address" checkbox is active by default
             */
            Validate.detachFields(addressesForm.querySelector("#billing-address"));
        }
    };

    static #prepareAddressesObject = (form) => {
        Trace.warn("address prepare obj");

        const shippingAddresses = [...(window.snakeCheckout.accountInfo.data.shippingAddresses || [{}])];
        let defaultShippingAddressIndex = shippingAddresses.findIndex((address) => address.defaultAddress);
        defaultShippingAddressIndex = defaultShippingAddressIndex !== -1 ? defaultShippingAddressIndex : 0;
        const shippingAddress = { ...(shippingAddresses[defaultShippingAddressIndex] || {}) };
        const billingAddress = { ...(window.snakeCheckout.accountInfo.data.billingAddress || {}) };

        const isSameAddresses = this.componentDom.querySelector("#same-addresses").checked;
        const formData = new FormData(form);

        let isDefaultShippingAddress = shippingAddress.defaultAddress || false;
        let isRepeater = false;
        let repeaterIndex = null;

        shippingAddress.county = billingAddress.county = null;
        shippingAddress.normCountryCode = billingAddress.normCountryCode = config.countries[window.snakeCheckout.currentCountry].countryCodeGigya;

        if (window.snakeCheckout.currentCountry !== "us") shippingAddress.state = billingAddress.state = config.countries[window.snakeCheckout.currentCountry].state || null;

        billingAddress.defaultAddress = true;
        billingAddress.label = "DEFAULT";

        /**
         * Populate billing and shipping objects with form data
         */
        Object.entries(Object.fromEntries(formData)).forEach((element) => {
            Trace.warn("address populate");

            const [key, value] = element;
            const match = key.match(/\[(.*?)\]/g);

            if (match) {
                const index = match.length - 1;
                const fieldName = match[index].replace(/[[\]]/g, "");

                Trace.warn(fieldName);

                isRepeater = index !== 0;
                if (isRepeater) repeaterIndex = match[0].replace(/[[\]]/g, "");

                if (key.startsWith("shipping")) {
                    if (fieldName === "defaultAddress") shippingAddress[fieldName] = isDefaultShippingAddress = value === "true";
                    else shippingAddress[fieldName] = value;
                }

                if (isDefaultShippingAddress && isSameAddresses) {
                    Trace.warn("isDefaultShippingAddress && isSameAddresses");
                    Trace.warn(shippingAddress[fieldName]);

                    billingAddress[fieldName] = shippingAddress[fieldName];
                } else if (key.startsWith("billing")) {
                    Trace.warn("startsWith");
                    Trace.warn(value);

                    billingAddress[fieldName] = value;
                }
            }
        });

        /**
         * To handle the CIF/NIF for ES, we save the taxCode on the billing address and remove the taxCode field from the shipping address to avoid validation errors on gigya
         *
         * To handle the CIF/NIF for ES, we show an alert if the default shipping address zip start with 35 or 38 and the taxCode on the billing address is missing
         */
        if (!isRepeater || isDefaultShippingAddress) {
            const zip = shippingAddress.postalCode;

            if (window.snakeCheckout.currentCountry === "es" && ["35", "38"].some((check) => zip.trim().replace(/\D/gu, "").startsWith(check))) {
                if (shippingAddress.taxCode) {
                    billingAddress.taxCode = shippingAddress.taxCode;
                } else {
                    if (!billingAddress.taxCode) {
                        Utils.modal("popup", true, { text: window.snakeCheckout.translations["error.defaultaddress.fiscalcode"], dismissBtn: this.modalI18nGenericOptions.dismissBtn });

                        return { shippingAddresses: null, billingAddress: null };
                    }
                }
            }
        }

        delete shippingAddress.taxCode;

        const billingPhoneData = JSON.parse(form.querySelector("[name='billing[phoneNumber]']")?.dataset.json || null);

        if (billingPhoneData) {
            billingAddress.phoneCountryCode = billingPhoneData.phoneCountryCode;
            billingAddress.phoneLineNumber = billingPhoneData.phoneLineNumber;
            billingAddress.phoneNumber = billingPhoneData.phoneNumber;
            billingAddress.phoneLineType = billingPhoneData.phoneLineType;
            billingAddress.phoneIsValid = billingPhoneData.phoneIsValid;
        }

        const shippingPhoneData = JSON.parse(form.querySelector("[name^='shipping'][name$='[phoneNumber]']")?.dataset.json || null);

        if (shippingPhoneData) {
            shippingAddress.phoneCountryCode = shippingPhoneData.phoneCountryCode;
            shippingAddress.phoneLineNumber = shippingPhoneData.phoneLineNumber;
            shippingAddress.phoneNumber = shippingPhoneData.phoneNumber;
            shippingAddress.phoneLineType = shippingPhoneData.phoneLineType;
            shippingAddress.phoneIsValid = shippingPhoneData.phoneIsValid;

            if (isDefaultShippingAddress && isSameAddresses) {
                billingAddress.phoneCountryCode = shippingAddress.phoneCountryCode;
                billingAddress.phoneLineNumber = shippingAddress.phoneLineNumber;
                billingAddress.phoneNumber = shippingAddress.phoneNumber;
                billingAddress.phoneLineType = shippingAddress.phoneLineType;
                billingAddress.phoneIsValid = shippingAddress.phoneIsValid;
            }
        }

        shippingAddresses[isRepeater ? repeaterIndex : defaultShippingAddressIndex] = shippingAddress;

        window.snakeCheckout.accountInfo.data.shippingAddressesOnOtherCountries.forEach((address) => shippingAddresses.push(address));

        return { shippingAddresses, billingAddress };
    };

    static #initAddressForm = (e) => {
        const repeaterItem = e.detail.event.target.closest(".repeater-item");
        const index = repeaterItem.dataset.index;

        /**
         * Replace form fields _INDEX_ placeholder on the repeater element and populate with user data if exists
         */
        repeaterItem.querySelectorAll("form input, form label, form select").forEach((element) => {
            if (element.tagName === "LABEL") {
                element.htmlFor = element.htmlFor.replace("_INDEX_", index);
            } else {
                element.name = element.name.replace("_INDEX_", index);
                element.id = element.id.replace("_INDEX_", index);

                const match = element.name.match(/\[(.*?)\]/g);

                if (match) {
                    const fieldName = match[1].replace(/[[\]]/g, "");

                    /**
                     * Check if user shipping data already exists
                     */
                    if (window.snakeCheckout.accountInfo.data.shippingAddresses[index]) {
                        element.value = window.snakeCheckout.accountInfo.data.shippingAddresses[index][fieldName] || "";

                        /**
                         * On ES, show CIF/NIF field if we have a value and the zip code start with 35 or 38
                         */
                        if (window.snakeCheckout.currentCountry === "es" && fieldName === "taxCode") {
                            const zip = window.snakeCheckout.accountInfo.data.shippingAddresses[index].postalCode;

                            if (["35", "38"].some((check) => zip.trim().replace(/\D/gu, "").startsWith(check))) {
                                element.value = window.snakeCheckout.accountInfo.data.billingAddress.taxCode || "";
                                element.parentElement.classList.remove("hidden");
                            }
                        }
                    }

                    if (fieldName === "country") element.value = config.countries[window.snakeCheckout.currentCountry].displayName;
                }
            }
        });

        const fieldLabel = repeaterItem.querySelector("[name$='[label]'][data-tagify='true']");
        if (fieldLabel && fieldLabel.dataset.tagify !== "init") {
            // eslint-disable-next-line no-new
            new Tagify(fieldLabel, {
                mode: "select",
                whitelist: [window.snakeCheckout.translations["address.field.label.work"], window.snakeCheckout.translations["address.field.label.home"], window.snakeCheckout.translations["address.field.label.office"]],
                originalInputValueFormat: (valuesArr) => valuesArr.map((item) => item.value).join(","),
            });

            fieldLabel.dataset.tagify = "init";
        }

        if (window.snakeCheckout.currentCountry === "us") {
            const fieldState = repeaterItem.querySelector("[name$='[state]'][data-tagify='true']");
            if (fieldState && fieldState.dataset.tagify !== "init") {
                // eslint-disable-next-line no-new
                new Tagify(fieldState, {
                    userInput: false,
                    enforceWhitelist: true,
                    mode: "select",
                    tagTextProp: "label",
                    dropdown: {
                        mapValueTo: "label",
                        maxItems: 100,
                        sortby: "startsWith",
                    },
                    whitelist: config.countries[window.snakeCheckout.currentCountry].states.sort((a, b) => (a.label > b.label ? 1 : -1)),
                    originalInputValueFormat: (valuesArr) => valuesArr.map((item) => item.value),
                });

                fieldState.dataset.tagify = "init";
            }
        }

        Utils.initPhoneNumber(repeaterItem.querySelector("[name$='[phoneNumber]']"), window.snakeCheckout.currentCountry, config.countries);

        if (!repeaterItem.querySelector("form").dataset.validationAttached) {
            Validate.attach(repeaterItem.querySelector("form"), (formIsValid) => {
                // Trace.debug("[7] Validate attach _editAddress response");
                // Trace.log(formIsValid);

                repeaterItem.querySelector('form button[type="submit"]').disabled = !formIsValid;
            });
        }

        repeaterItem.querySelector(":scope > div").classList.add("hidden");
        repeaterItem.querySelector(":scope > form").classList.remove("hidden");
        this.componentDom.querySelector('[data-add="addresses-repeater"]').disabled = true;
    };

    static #updateAddresses = async (shippingAddresses, billingAddress) => {
        Trace.warn("address update");
        Trace.print(shippingAddresses);
        Trace.print(billingAddress);

        await Identity.setAddresses(shippingAddresses, billingAddress)
            .then(async (response) => {
                Trace.debug("_cmpAddresses setAddresses response");
                Trace.debug(response);

                if (response.errorCode !== 0) {
                    Utils.modal("popup", true, this.modalI18nGenericOptions);

                    AnalyticsService.errorEvent("2_shipping", "technical", "gproxy | set user addresses response error", response);
                } else {
                    // Trace.debug("Success setAddresses first");

                    window.snakeCheckout.accountInfo.data.shippingAddresses = shippingAddresses.filter((address) => address.normCountryCode === config.countries[window.snakeCheckout.currentCountry].countryCodeGigya);
                    window.snakeCheckout.accountInfo.data.billingAddress = billingAddress;

                    if (Identity.isAgentCustomer()) {
                        window.location.href = "/" + config.countries[window.snakeCheckout.currentCountry].countryCode.toLowerCase() + "/subscribe/confirmation-customer-agent";
                    } else Component.load(config.routing.sections.addresses.component);
                }
            })
            .catch((e) => {
                Trace.debug("_cmpAddresses setAddresses error");
                Trace.debug(e);

                Utils.modal("popup", true, this.modalI18nGenericOptions);

                AnalyticsService.errorEvent("2_shipping", "technical", "gproxy | set user addresses error", e);
            });
    };

    static #renderUserDefaultShippingAddress = () => {
        // Trace.warn("renderUserDefaultShippignAddress");

        const defaultShippingAddress = window.snakeCheckout.accountInfo.data.shippingAddresses.find((address) => address.defaultAddress);

        /**
         * Replace HTML placeholders with user default shipping address
         */
        this.componentDom.querySelector(".next-times .address-info shippingaddress").innerHTML = defaultShippingAddress.addressLine1 || "";
        this.componentDom.querySelector(".next-times .address-info shippingstreetnumber").innerHTML = defaultShippingAddress.normStreetNum || "";
        this.componentDom.querySelector(".next-times .address-info shippingzip").innerHTML = defaultShippingAddress.postalCode || "";
        this.componentDom.querySelector(".next-times .address-info shippingcity").innerHTML = defaultShippingAddress.city || "";

        this.componentDom.querySelector(".first-time").classList.add("hidden");
        this.componentDom.querySelector(".next-times").classList.remove("hidden");

        this.componentDom.querySelector(".next-times .address-info").classList.remove("hidden");
        this.componentDom.querySelector(".next-times > form").classList.add("hidden");
        this.componentDom.querySelector("[data-repeater='addresses-repeater']").classList.add("hidden");

        this.componentDom.querySelector("#addresses-repeater").replaceChildren();

        this.componentDom.querySelector('[data-add="addresses-repeater"]').disabled = false;
        this.componentDom.querySelector('[data-hook="_setAddresses"]').disabled = false;
    };

    static #renderUserShippingAddresses = () => {
        // Trace.warn("renderUserShippingAddresses");

        /**
         * Empty the repeater container to be sure that multiple editing does not break the shipping address indexes.
         */
        this.componentDom.querySelector("#addresses-repeater").replaceChildren();

        /**
         * We create a repeater element for each user shipping address
         */
        this.componentDom.querySelector('[data-add="addresses-repeater"]').disabled = false;

        // Trace.warn("renderUserShippignAddresses repeater PRE");
        // Trace.log(window.snakeCheckout.accountInfo.data.shippingAddresses);

        window.snakeCheckout.accountInfo.data.shippingAddresses.forEach((address) => {
            // Trace.warn("renderUserShippignAddresses repeater FOR");

            this.componentDom.querySelector("[data-add='addresses-repeater']").click();
        });

        /**
         * Enable trash icon only for non default addresses
         */
        for (const deleteRepeaterButton of this.componentDom.querySelectorAll(".address-list [data-delete='addresses-repeater']")) {
            if (!deleteRepeaterButton.closest(".address-options").querySelector(':scope > [type="radio"]').checked) deleteRepeaterButton.classList.remove("hidden");
            else deleteRepeaterButton.classList.add("hidden");
        }

        this.componentDom.querySelector(".next-times .address-info").classList.add("hidden");
        this.componentDom.querySelector(".next-times > form").classList.remove("hidden");
        this.componentDom.querySelector("[data-repeater='addresses-repeater']").classList.remove("hidden");
    };

    static validateCifNif = () => {
        /**
         * To handle the CIF/NIF for ES, we show an alert if the default shipping address zip start with 35 or 38 and the taxCode on the billing address is missing
         */

        const defaultShippingAddressZip = window.snakeCheckout.accountInfo.data.shippingAddresses.find((address) => address.defaultAddress).postalCode;

        if (window.snakeCheckout.currentCountry === "es" && ["35", "38"].some((check) => defaultShippingAddressZip.trim().replace(/\D/gu, "").startsWith(check)) && !window.snakeCheckout.accountInfo.data.billingAddress.taxCode) {
            Utils.modal("popup", true, { text: window.snakeCheckout.translations["error.order.fiscalcode"], dismissBtn: this.modalI18nGenericOptions.dismissBtn });

            return false;
        }

        return true;
    };
}
